export const BOOLEAN_OPTION_SET = new Set<string>([
    "SlowdownManager_Enabled",
    "SlowDownZonedManager_Enabled",
    "DBWriter_Enabled",
    "MqttSender_Enabled",
    "CmdWriter_Enabled",
    "MailSender_Enabled",
    "MailSender_UseSSL",
    "SmsSender_Enabled",
    "LightSender_Enabled",
    "LightSender_ResetOnStartup",
    "SlowdownBlueboxSender_Enabled",
    "KafkaSender_Enabled",
    "ApiCaller_Enabled",
    "DeviceMover_Enabled",
    "GroupChanger_Enabled",
    "LogEvent",
    "DeviceCreatedEnabled",
    "UpdateWakeup",
    "WarnIfCannotCalculatePosition",
    "AskConfigOnServerRestart",
    "MqttTlsEnabled",
    "MqttUseUsernamePassword",
    "MqttInternalBroker",
    "MqttStartExternalBroker",
    "NoLocationZonesEnabled",
    "RailsEnabled",
    "SentinelPresenceEnabled",
    "DynamicLikelihoodThresholdEnabled",
    "KeepLastKnownPosition",
    "Enabled",
    "BatteryDBWriter_Enabled",
    "KafkaPositionSender_Enabled",
    "UDPSender_Enabled",
    "BeaconUpdater_Enabled",
    "BeaconUpdater_Filter",
    "BeaconUpdater_SaveBleContacts",
    "BeaconUpdater_SaveOpenContacts",
    "BeaconUpdater_DontSaveIfDeviceExists",
    "ReloadUpdater_SendUpdateOnGroupChange",
    "ZoneAccess_Enabled",
    "ZoneExit_Enabled",
    "ZoneChangeFilter_Enabled",
    "DeviceChargedAttached_Enabled",
    "DeviceChargedDetached_Enabled",
    "DeviceCharged_FillStockAndPicking",
    "Tamper_Enabled",
    "Inactivity_Enabled",
    "FirmwareUpdate_Enabled",
    "ManDown_Enabled",
    "ManDownCanceled_Enabled",
    "ManDown_IgnoreIfAlreadyActive",
    "ManDown_PreAlarmIsAlarm",
    "Button1_Enabled",
    "Button2_Enabled",
    "Button3_Enabled",
    "Button4_Enabled",
    "Button5_Enabled",
    "BatteryChanged_Enabled",
    "Contact_Enabled",
    "KafkaEventSender_Enabled",
    "Geofence_Enabled",
    "BleSensor_Enabled",
    "Commands_Enabled",
    "KeepAlive_Enabled",
    "RiskUpdater_Enabled",
    "InfoMail_Enabled",
    "AutoAckWorker_Enabled",
    "BeaconClean_Enabled",
    "AdvancedTrain_1_Enabled",
    "AdvancedTrain_2_Enabled",
    "DiagnosticMqttSender_Enabled",
    "ScheduledReportAccelerationThreshold_Enabled",
    "ScheduledReportSender_Enabled",
    "File_Enabled",
    "File_DeviceMessage",
    "DB_BulkInsert",
    "Console_Enabled",
    "Console_DeviceMessage",
    "ApplicationInsights_Enabled",
    "DeviceEnricher_Enabled",
    "DeviceEnricher_AddDefaultBindingWithTranslatedMac",
    "ItemEnricher_Enabled",
    "SystemInfoEnricher_Enabled",
    "SafetyEnricher_Enabled",
    "WeatherEnricher_Enabled",
    "PositionEnricher_Enabled",
    "ContactEnricher_Enabled",
    "PositionRelationEnricher_Enabled",
    "PositionRelationEnricher_LimitWithAngularSpeed",
    "PositionBLEIndirectRelationEnricher_MinRssi",
    "OdometerInCustomInfo_Enabled",
    "OdometerIsGeoreferenced",
    "SpeedInCustomInfo_Enabled",
    "ReverseGeocoding_Enabled",
    "AvoidSerialNumberOverride",
    "PerFloorLocation",
    "Smooth",
    "Buffer",
    "FilterOldLastUpdateBleScan",
    "PerFloorLocationTakeStrongest",
    "PerFloorLocationTakeStrongAverage",
    "WeightWithBeaconIndex",
    "MixedWithIndirectHint",
    "UseMixedMacAndUUID",
    "UsePresenceBeacons",
    "TakeStrongestOnly",
    "UsePremiumLicense",
    "NormalizeId",
    "CheckId",
    "WarningForUnkownMessage",
    "CheckMsgCount",
    "Secured",
    "SendRanging",
    "SendConfiguration",
    "AzureEnabled",
    "UseUtcTimestamp",
    "OnPremiseInstance",
    "SqlEnabled",
    "SqlMultipleActiveResultSets",
    "TrustedServerCertificate",
    "Encrypt",
    "SendUdp",
    "InvertY",
    "IgnoreClrZero",
    "TrancodeProximityMac",
    "UseCertificate",
    "KafkaErrorSender_EhConnString",
    "KafkaPositionReceiver_Enabled",
    "KafkaTelemetryReceiver_Enabled",
    "KafkaMixReceiver_Enabled",
    "DB_Enabled",
    "DB_DeviceMessage",
    "CheckIntegrity",
    "DiscardIfIntegrityFail",
    "InferDeviceTypeFromAvlIds",
    "UseUUIDs",
    "FilterLocationResultWithLenght",
    "FilterLocationResultFirstAndLast",
    "DiscardNotSensors",
    "SendDataToThirdParty",
    "EnableTestApiEndpoint",
    "UplinkMqttUseUsernamePassword",
    "UplinkMqttUseTLS",
    "UplinkMqttUseCertificate",
    "MqttWebSocket_Enabled"
]);

export const isBooleanOption = (id: string) => {
    return BOOLEAN_OPTION_SET.has(id) || id.endsWith("_Enabled") || id.endsWith("Enabled");
};